import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 864.000000 888.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,888.000000) scale(0.100000,-0.100000)">
        <path d="M0 8865 c0 -13 487 -15 4320 -15 3833 0 4320 2 4320 15 0 13 -487 15
-4320 15 -3833 0 -4320 -2 -4320 -15z"/>
<path d="M1290 8305 l-34 -35 132 -132 132 -132 130 129 c72 71 130 133 130
138 0 4 -15 21 -32 38 l-32 29 -196 0 -196 0 -34 -35z"/>
<path d="M350 8323 c132 -7 290 -7 290 0 0 4 -78 6 -172 5 -95 -1 -148 -3
-118 -5z"/>
<path d="M725 8313 c-5 -12 -9 -14 -12 -5 -11 29 -48 8 -131 -76 -48 -48 -99
-103 -114 -120 l-27 -32 -42 45 c-23 25 -46 45 -51 45 -6 0 11 -20 36 -45 25
-25 46 -51 46 -58 0 -6 -21 -33 -47 -59 l-47 -48 169 -170 c93 -93 174 -170
180 -170 6 0 87 76 180 170 l170 170 -110 111 c-61 61 -131 132 -157 156 -53
50 -56 58 -31 85 9 10 11 18 6 18 -6 0 -14 -8 -18 -17z"/>
<path d="M1210 8215 c18 -19 36 -32 39 -30 4 5 -58 65 -68 65 -3 0 10 -16 29
-35z"/>
<path d="M312 8213 c2 -14 10 -29 18 -31 13 -5 13 -3 1 11 -7 9 -11 24 -7 32
3 8 1 15 -5 15 -6 0 -9 -12 -7 -27z"/>
<path d="M1124 8196 c-10 -8 -17 -17 -14 -19 3 -3 14 1 24 9 11 7 17 16 15 19
-3 3 -14 -2 -25 -9z"/>
<path d="M449 8133 c-13 -15 -12 -15 9 -4 23 12 28 21 13 21 -5 0 -15 -7 -22
-17z"/>
<path d="M1060 8129 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M1295 8130 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M1111 8104 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1320 8100 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1016 8082 c-3 -5 3 -17 14 -27 23 -21 26 -9 6 18 -8 10 -17 14 -20
9z"/>
<path d="M1345 8079 c-4 -6 -16 -14 -28 -18 -11 -4 -16 -10 -11 -14 6 -3 23 5
40 18 16 13 24 24 17 25 -6 0 -15 -5 -18 -11z"/>
<path d="M1060 8033 c0 -5 9 -18 20 -28 11 -10 20 -15 20 -11 0 4 -9 16 -20
28 -11 12 -20 17 -20 11z"/>
<path d="M1111 7983 c-2 -20 16 -24 30 -5 13 15 12 16 -3 4 -13 -10 -17 -10
-21 0 -4 9 -6 9 -6 1z"/>
<path d="M1226 7959 c-11 -11 -15 -19 -9 -19 12 0 38 28 32 34 -2 2 -13 -5
-23 -15z"/>
<path d="M1140 7950 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1160 7923 c0 -1 9 -7 19 -12 14 -8 20 -7 24 3 4 10 -2 13 -19 12
-13 0 -24 -2 -24 -3z"/>
<path d="M2770 7740 c-25 -25 -26 -72 -2 -93 15 -14 42 -17 159 -17 130 0 141
-2 159 -21 18 -20 19 -54 24 -917 l5 -896 110 -84 c61 -45 124 -94 140 -107
17 -14 36 -25 43 -25 9 0 12 204 12 989 0 693 3 997 11 1020 7 20 20 33 37 38
43 10 714 -6 912 -22 252 -21 374 -41 560 -94 298 -84 526 -202 735 -382 269
-231 464 -537 566 -888 96 -334 113 -784 43 -1130 -93 -453 -342 -877 -664
-1132 -45 -35 -85 -65 -89 -67 -5 -2 -11 64 -14 145 -3 102 -12 174 -26 232
l-21 83 49 57 c239 276 352 638 354 1141 1 405 -70 699 -241 985 -20 33 -38
62 -41 65 -3 3 -22 25 -41 50 -89 117 -233 243 -367 324 -74 44 -253 130 -315
150 -252 84 -445 115 -828 132 -139 6 -146 5 -172 -16 -36 -28 -38 -71 -4 -98
21 -16 48 -20 203 -25 498 -18 809 -101 1103 -295 103 -68 259 -222 322 -317
164 -249 248 -566 248 -941 0 -390 -72 -688 -224 -931 -83 -132 -107 -155
-120 -115 -11 32 -101 160 -159 226 -75 84 -111 106 -176 107 -44 1 -58 -3
-89 -28 -20 -17 -43 -41 -49 -54 -44 -85 34 -199 136 -199 76 0 151 63 151
126 0 19 3 34 8 34 21 0 170 -219 171 -251 2 -40 -233 -225 -379 -299 -104
-53 -330 -130 -381 -130 -10 0 -26 24 -45 73 -109 275 -288 497 -609 753 -55
44 -136 109 -181 144 -44 36 -96 76 -114 90 -18 14 -68 52 -109 86 -117 93
-299 237 -486 384 -226 179 -256 205 -310 275 -174 224 -180 557 -13 812 43
67 170 193 194 193 11 0 14 23 14 109 0 61 -4 112 -8 115 -11 7 -117 -42 -192
-88 -65 -41 -203 -170 -257 -241 -89 -118 -157 -280 -188 -450 -22 -114 -16
-338 10 -435 28 -103 96 -238 162 -320 75 -93 70 -88 360 -316 131 -103 290
-229 353 -279 63 -50 151 -119 195 -154 44 -35 89 -70 100 -79 11 -10 81 -64
155 -122 172 -133 340 -300 412 -410 55 -84 105 -186 96 -196 -3 -2 -123 -7
-267 -11 -260 -6 -263 -7 -278 -29 -19 -29 -9 -80 19 -95 13 -7 115 -10 299
-8 153 1 282 -1 286 -5 16 -16 33 -95 45 -204 9 -89 9 -115 -1 -125 -19 -19
-851 -24 -851 -5 0 7 0 241 0 519 0 279 -2 514 -6 522 -3 9 -38 42 -77 74 -40
32 -81 65 -92 75 -11 9 -45 37 -75 62 l-55 45 -3 -655 -2 -655 -113 3 -112 3
-3 110 c-3 123 -13 145 -67 145 -60 0 -65 -16 -65 -213 l0 -177 180 0 180 0 0
-150 c0 -160 -9 -200 -53 -249 -27 -30 -93 -60 -129 -61 -16 0 -28 -4 -28 -10
0 -10 1219 -17 2138 -12 l482 2 0 414 0 414 97 68 c88 62 273 234 349 324 259
308 443 753 484 1170 12 122 12 437 0 560 -30 315 -135 646 -282 888 -44 73
-154 228 -182 258 -6 6 -35 39 -65 74 -30 34 -98 99 -150 144 -375 323 -832
485 -1491 526 -91 5 -463 10 -827 10 -650 0 -663 0 -683 -20z m2710 -3501 c20
-94 27 -264 14 -329 -8 -38 -44 -63 -209 -145 -165 -82 -408 -163 -545 -181
l-48 -6 -7 103 c-4 57 -13 137 -20 177 -9 54 -9 75 -1 77 6 2 54 15 106 30
228 63 459 186 615 328 33 31 64 52 68 48 4 -5 17 -50 27 -102z m-40 -565 c0
-21 -109 -217 -155 -278 -114 -152 -290 -291 -460 -364 -152 -65 -256 -90
-425 -102 -131 -10 -949 -14 -972 -5 -10 4 -12 51 -10 235 l3 230 414 0 c354
0 415 -2 415 -14 0 -33 -32 -148 -59 -215 l-29 -71 212 0 212 0 12 33 c29 71
51 149 68 231 16 84 17 86 45 86 40 0 318 72 419 109 47 17 130 53 185 80 96
48 125 58 125 45z"/>
<path d="M510 7285 c-131 -131 -134 -135 -120 -160 13 -25 13 -25 32 -5 20 21
44 28 32 9 -4 -7 -1 -10 7 -7 14 5 69 -52 69 -71 0 -6 5 -11 10 -11 20 0 52
-38 44 -51 -5 -9 -2 -10 9 -6 9 3 19 2 22 -3 9 -14 -6 -40 -23 -40 -12 0 -5
-12 21 -37 l37 -38 135 135 c74 74 135 139 135 144 0 10 -261 276 -270 276 -3
0 -66 -61 -140 -135z"/>
<path d="M3562 7069 l3 -91 81 -27 c105 -34 182 -81 263 -162 95 -94 161 -236
161 -346 0 -57 8 -73 36 -73 l24 0 0 198 c0 108 -3 275 -7 370 l-6 172 -107 0
c-68 0 -160 9 -254 25 -216 37 -197 43 -194 -66z"/>
<path d="M363 7061 c-23 -19 -29 -31 -15 -31 4 0 15 12 25 25 21 30 19 31 -10
6z"/>
<path d="M310 6985 c0 -14 2 -25 4 -25 2 0 6 11 8 25 3 14 1 25 -3 25 -5 0 -9
-11 -9 -25z"/>
<path d="M310 6944 c0 -4 11 -17 25 -30 14 -13 25 -20 25 -15 0 4 -11 17 -25
29 -14 12 -25 19 -25 16z"/>
<path d="M450 6876 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M504 6865 c-10 -8 -14 -15 -8 -15 6 0 17 7 24 15 16 19 9 19 -16 0z"/>
<path d="M475 6830 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M432 6810 c7 -11 16 -20 20 -20 5 0 3 9 -4 20 -7 11 -16 20 -20 20
-5 0 -3 -9 4 -20z"/>
<path d="M2200 4439 c-190 -229 -280 -417 -335 -707 -40 -205 2 -498 102 -717
81 -177 227 -355 377 -459 165 -114 418 -214 607 -240 205 -29 479 -24 647 10
286 59 508 172 700 359 45 44 82 83 82 87 0 5 -102 8 -228 8 l-227 0 -60 -45
c-96 -73 -264 -151 -400 -187 -117 -31 -126 -32 -340 -32 -210 -1 -225 0 -317
26 -322 90 -586 305 -722 588 -110 227 -118 602 -20 888 37 109 114 263 179
360 30 46 55 86 55 89 0 7 -32 32 -42 33 -4 0 -30 -28 -58 -61z"/>
<path d="M2772 4440 c-21 -20 -22 -30 -22 -165 0 -132 2 -147 20 -165 25 -25
72 -26 93 -2 14 16 17 43 17 164 0 138 -1 145 -23 166 -29 27 -57 28 -85 2z"/>
<path d="M2363 2123 l-33 -4 0 -220 0 -219 155 0 155 0 0 35 0 35 -92 1 c-51
1 -100 2 -108 3 -13 1 -16 31 -20 185 -3 111 -9 185 -15 186 -5 1 -25 0 -42
-2z"/>
<path d="M3440 2090 c0 -40 0 -40 39 -40 43 0 49 8 43 52 -4 25 -8 28 -43 28
-39 0 -39 0 -39 -40z"/>
<path d="M4557 2124 c-4 -4 -7 -106 -7 -226 l0 -218 40 0 c37 0 40 2 40 28 0
15 4 22 8 16 32 -47 121 -59 167 -22 38 30 55 76 55 151 0 99 -48 157 -131
157 -19 0 -44 -7 -55 -15 -38 -29 -46 -20 -43 58 l2 72 -34 3 c-19 2 -38 0
-42 -4z m202 -200 c32 -40 29 -126 -4 -159 -29 -29 -55 -32 -84 -7 -25 19 -42
83 -34 123 13 68 84 92 122 43z"/>
<path d="M5150 2055 c0 -41 -2 -75 -4 -75 -2 0 -17 7 -32 15 -62 32 -134 11
-170 -49 -14 -22 -19 -50 -19 -101 0 -79 19 -121 65 -149 38 -22 99 -20 130 4
32 25 40 25 40 0 0 -16 7 -20 35 -20 l35 0 0 225 0 225 -40 0 -40 0 0 -75z
m-20 -132 c31 -39 25 -137 -9 -164 -27 -22 -59 -24 -85 -4 -22 17 -37 86 -29
133 11 63 84 84 123 35z"/>
<path d="M3655 2090 c-20 -13 -32 -30 -35 -52 -3 -20 -11 -33 -20 -33 -9 0
-16 -11 -18 -28 -3 -22 1 -30 16 -34 18 -4 21 -15 24 -113 4 -132 14 -150 89
-150 53 0 62 8 53 44 -4 17 -14 26 -32 28 -27 3 -27 4 -30 96 l-3 92 31 0 c28
0 30 3 30 36 0 33 -2 35 -27 32 -27 -3 -28 -1 -31 50 -2 28 -6 52 -10 52 -4 0
-20 -9 -37 -20z"/>
<path d="M5716 2095 c-10 -8 -23 -16 -28 -17 -5 -2 -13 -19 -17 -38 -4 -21
-13 -35 -21 -35 -9 0 -16 -12 -18 -28 -3 -22 1 -30 16 -34 18 -4 20 -16 24
-115 3 -102 5 -112 27 -130 18 -14 37 -18 70 -16 44 3 46 4 46 33 0 25 -4 30
-27 33 l-28 3 0 94 0 94 27 3 c20 2 27 9 30 31 3 24 0 28 -27 33 -28 6 -30 9
-30 55 0 52 -10 60 -44 34z"/>
<path d="M8176 2051 c-3 -5 3 -11 13 -14 14 -3 18 -1 14 9 -6 16 -19 18 -27 5z"/>
<path d="M2775 2000 c-102 -42 -116 -233 -22 -297 46 -32 128 -32 173 -1 41
28 60 64 38 72 -30 11 -61 6 -79 -14 -34 -38 -97 -19 -110 33 l-7 27 107 0
107 0 -4 53 c-5 61 -28 99 -75 122 -33 16 -95 19 -128 5z m107 -67 c10 -9 18
-27 18 -40 0 -23 -2 -24 -62 -21 -34 2 -63 8 -65 14 -2 6 6 23 17 37 25 31 64
36 92 10z"/>
<path d="M3125 2000 c-56 -23 -90 -97 -82 -177 5 -49 11 -62 45 -96 33 -33 47
-40 80 -40 25 0 52 8 71 22 l31 22 0 -44 c0 -49 -10 -61 -56 -71 -22 -5 -37
-2 -55 12 -23 19 -92 35 -102 25 -13 -12 18 -65 46 -80 47 -24 160 -22 195 4
49 36 52 54 49 248 l-2 180 -32 3 c-28 3 -33 0 -33 -17 0 -26 -2 -26 -42 -1
-34 21 -78 25 -113 10z m111 -58 c21 -14 34 -51 34 -97 0 -80 -72 -124 -120
-73 -11 12 -20 33 -21 47 -3 68 3 97 23 114 21 17 64 22 84 9z"/>
<path d="M3440 1845 l0 -165 40 0 40 0 1 133 c2 135 2 176 0 190 -1 4 -19 7
-41 7 l-40 0 0 -165z"/>
<path d="M3858 1994 c-33 -17 -48 -43 -48 -81 0 -56 43 -85 157 -108 38 -8 47
-18 38 -45 -9 -28 -84 -28 -110 0 -19 21 -79 28 -90 10 -9 -15 24 -58 58 -75
35 -18 129 -20 160 -4 47 24 67 51 67 91 0 50 -24 73 -97 93 -107 29 -140 60
-80 76 30 8 87 -7 87 -22 0 -11 51 -12 69 0 20 13 -12 57 -51 70 -44 15 -128
13 -160 -5z"/>
<path d="M4177 2004 c-11 -12 -8 -228 4 -263 21 -59 104 -79 167 -41 40 25 42
25 42 0 0 -16 7 -20 35 -20 l35 0 -2 163 -3 162 -35 0 -35 0 -5 -117 c-5 -128
-15 -147 -71 -148 -44 0 -53 22 -59 149 l-5 116 -30 3 c-17 2 -34 0 -38 -4z"/>
<path d="M5374 2001 c-21 -9 -64 -57 -64 -71 0 -4 15 -10 33 -13 23 -3 38 1
53 14 23 21 74 25 92 7 21 -21 14 -47 -15 -54 -53 -11 -128 -34 -139 -41 -6
-5 -16 -18 -23 -30 -32 -62 15 -133 89 -133 23 0 55 8 72 18 28 16 30 16 39 0
7 -12 22 -18 46 -18 34 0 35 1 29 31 -3 17 -6 78 -6 135 0 94 -2 105 -24 131
-21 24 -31 28 -92 30 -38 2 -79 -1 -90 -6z m124 -198 c-4 -49 -42 -79 -81 -64
-32 12 -44 37 -30 60 8 13 70 37 106 40 5 1 7 -15 5 -36z"/>
<path d="M5924 1995 c-27 -14 -61 -61 -51 -71 2 -2 18 -5 36 -6 22 -2 36 3 42
15 14 25 85 23 99 -2 17 -32 12 -38 -37 -51 -130 -33 -153 -50 -153 -111 0
-74 98 -115 172 -71 28 16 30 16 39 0 6 -12 22 -18 42 -18 l33 0 -3 103 c-7
207 -14 220 -121 225 -47 2 -76 -2 -98 -13z m134 -183 c10 -68 -98 -111 -114
-45 -8 31 12 52 57 63 45 10 53 8 57 -18z"/>
<path d="M8240 2004 c1 -11 60 -77 65 -72 2 1 -12 21 -31 42 -19 22 -34 35
-34 30z"/>
<path d="M7852 1857 c-73 -73 -132 -137 -132 -143 0 -10 253 -267 268 -272 4
-1 67 58 141 132 123 123 132 135 120 154 -10 16 -20 20 -50 16 -34 -4 -41 0
-113 69 -75 72 -86 87 -66 87 6 0 23 12 38 27 15 15 19 21 9 13 -16 -11 -22
-9 -50 18 l-33 32 -132 -133z"/>
<path d="M8130 1940 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M8322 1905 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M7777 1072 c-92 -92 -167 -172 -167 -177 0 -6 67 -77 150 -160 82
-82 154 -162 161 -177 13 -33 39 -36 59 -9 7 11 18 17 23 14 6 -3 7 -1 4 5 -6
8 46 64 180 191 12 12 19 9 47 -18 47 -46 51 -38 4 10 l-41 41 47 47 c25 26
46 51 46 56 0 10 -331 345 -340 345 -3 0 -81 -75 -173 -168z"/>
<path d="M7410 915 c-19 -19 -29 -35 -23 -35 5 0 22 14 37 32 l26 32 40 -39
c22 -22 40 -36 40 -32 0 9 -72 77 -81 77 -3 0 -20 -16 -39 -35z"/>
<path d="M7555 830 c16 -16 35 -30 42 -30 8 0 -2 14 -20 30 -19 17 -38 30 -43
30 -4 0 5 -13 21 -30z"/>
<path d="M6987 722 c-70 -70 -127 -132 -127 -139 0 -6 14 -23 31 -37 l31 -26
194 0 194 0 36 33 35 32 -133 133 -133 132 -128 -128z"/>
<path d="M7520 779 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7606 773 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M7550 765 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M7345 760 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"/>
<path d="M7310 750 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7565 730 c-10 -11 -14 -20 -9 -20 5 0 17 9 27 20 9 11 13 20 8 20
-4 0 -16 -9 -26 -20z"/>
<path d="M7498 713 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7350 701 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3
-10 2 -10 -4z"/>
<path d="M7516 688 c3 -5 10 -6 15 -3 13 9 11 12 -6 12 -8 0 -12 -4 -9 -9z"/>
<path d="M8285 690 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z"/>
<path d="M7445 679 c-4 -6 -4 -13 -1 -16 3 -4 6 -1 6 5 0 6 8 13 18 15 15 4
15 5 0 6 -9 0 -20 -4 -23 -10z"/>
<path d="M7380 670 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8318 610 l4 -69 -161 -4 -161 -3 162 1 163 0 3 57 c2 32 -1 65 -5
73 -5 8 -7 -15 -5 -55z"/>
<path d="M7485 660 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M7430 621 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5 3
-10 2 -10 -4z"/>
<path d="M7905 540 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M0 25 l0 -25 4320 0 4320 0 0 25 0 25 -4320 0 -4320 0 0 -25z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
